"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconUnderline', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M6 2C6 1.44772 5.55228 1 5 1 4.44772 1 4 1.44772 4 2V8C4 9.11639 4.34909 10.1381 5.08495 10.8841 5.82299 11.6323 6.84839 12 8 12 9.15161 12 10.177 11.6323 10.9151 10.8841 11.6509 10.1381 12 9.11639 12 8V2C12 1.44772 11.5523 1 11 1 10.4477 1 10 1.44772 10 2V8C10 8.70179 9.78659 9.18011 9.4912 9.47956 9.19799 9.77682 8.72339 10 8 10 7.27661 10 6.80201 9.77682 6.5088 9.47956 6.21341 9.18011 6 8.70179 6 8V2zM4 13C3.44772 13 3 13.4477 3 14 3 14.5523 3.44772 15 4 15H12C12.5523 15 13 14.5523 13 14 13 13.4477 12.5523 13 12 13H4z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M7 3C7 2.44772 6.55228 2 6 2 5.44772 2 5 2.44772 5 3V10C5 11.3373 5.22901 12.8122 5.98968 13.9825 6.79517 15.2217 8.12097 16 10 16 11.879 16 13.2048 15.2217 14.0103 13.9825 14.771 12.8122 15 11.3373 15 10V3C15 2.44772 14.5523 2 14 2 13.4477 2 13 2.44772 13 3V10C13 11.1627 12.7915 12.1878 12.3334 12.8925 11.9202 13.5283 11.246 14 10 14 8.75403 14 8.07983 13.5283 7.66657 12.8925 7.20849 12.1878 7 11.1627 7 10V3zM5 17C4.44772 17 4 17.4477 4 18 4 18.5523 4.44772 19 5 19H15C15.5523 19 16 18.5523 16 18 16 17.4477 15.5523 17 15 17H5z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M8 2C8 1.44772 7.55228 1 7 1 6.44772 1 6 1.44772 6 2V13C6 14.3986 6.3477 15.9043 7.32553 17.0777 8.3301 18.2831 9.88453 19 12 19 14.1155 19 15.6699 18.2831 16.6745 17.0777 17.6523 15.9043 18 14.3986 18 13V2C18 1.44772 17.5523 1 17 1 16.4477 1 16 1.44772 16 2V13C16 14.1014 15.7227 15.0957 15.138 15.7973 14.5801 16.4668 13.6345 17 12 17 10.3655 17 9.4199 16.4668 8.86197 15.7973 8.2773 15.0957 8 14.1014 8 13V2zM5 21C4.44772 21 4 21.4477 4 22 4 22.5523 4.44772 23 5 23H19C19.5523 23 20 22.5523 20 22 20 21.4477 19.5523 21 19 21H5z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M10 3.5C10 2.67157 9.32843 2 8.5 2 7.67157 2 7 2.67157 7 3.5V16C7 18.2863 7.70881 20.7441 9.18606 22.6646 10.6932 24.6238 12.992 26 16 26 18.9455 26 21.2553 24.8008 22.7963 22.8745 24.3051 20.9885 25 18.5088 25 16V3.5C25 2.67157 24.3284 2 23.5 2 22.6716 2 22 2.67157 22 3.5V16C22 17.9912 21.4449 19.7615 20.4537 21.0005 19.4947 22.1992 18.0545 23 16 23 14.008 23 12.5568 22.1262 11.5639 20.8354 10.5412 19.5059 10 17.7137 10 16V3.5zM6.5 27C5.67157 27 5 27.6716 5 28.5 5 29.3284 5.67157 30 6.5 30H25.5C26.3284 30 27 29.3284 27 28.5 27 27.6716 26.3284 27 25.5 27H6.5z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;